import React from 'react';
/* eslint-disable */
/**
 * Generate JSX for social SVG
 * @param {string} socialMedia Which icon generate
 * @return {JSX} JSX for the corresponding social icon
 */
export const SVGIcon = (socialMedia) => {
  let outIcon = <div />;
  switch (socialMedia) {
  case 'facebook':
    outIcon = (
      <svg width="22px" height="47px" viewBox="0 0 22 47">
        <desc>Created with Sketch.</desc>
        <defs />
        <g id="Home-Page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            className="social-stroke"
            transform="translate(-391.000000, -3103.000000)"
            id="Group-9"
            strokeWidth="1.33279996"
          >
            <g transform="translate(364.000000, 3089.000000)">
              <path
                d="M32.5723545,60.2608696 L32.5723545,37.8276034 L28.1217391,37.8276034 L28.1217391,30.0978524 L32.5723545,30.0978524 L32.5723545,25.4571705 C32.5723545,19.151619 35.0840745,15.4 42.2246521,15.4 L48.1678768,15.4 L48.1678768,23.1325824 L44.4533614,23.1325824 C41.6735976,23.1325824 41.4899128,24.2127655 41.4899128,26.2287298 L41.4776671,30.0978524 L48.2086957,30.0978524 L47.4208918,37.8276034 L41.4776671,37.8276034 L41.4776671,60.2608696 L32.5723545,60.2608696 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </svg>
    );
    break;
  case 'twitter':
    outIcon = (
      <svg width="45px" height="39px" viewBox="0 0 45 39">
        <desc>Created with Sketch.</desc>
        <defs />
        <g id="Home-Page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            className="social-stroke"
            transform="translate(-491.000000, -3108.000000)"
            id="Group-7"
            strokeWidth="1.33279996"
          >
            <g transform="translate(475.000000, 3089.000000)">
              <path
                d="M54.268031,26.4727305 C55.9421602,25.3446345 57.2267413,23.5558711 57.8296133,21.4250231 C56.2621461,22.4721678 54.5300484,23.2294544 52.6820138,23.6394338 C51.2072961,21.8637271 49.0995628,20.7565217 46.7669119,20.7565217 C42.2917466,20.7565217 38.6652396,24.8432585 38.6652396,29.8831318 C38.6652396,30.5986372 38.732483,31.2958632 38.8716073,31.9617532 C32.1379907,31.5804985 26.1672391,27.9507452 22.1674152,22.4251638 C21.4694749,23.7778344 21.0706519,25.3446345 21.0706519,27.0158878 C21.0706519,30.1808238 22.5013135,32.9749505 24.6762902,34.6148679 C23.3476531,34.5678639 22.097853,34.1526619 21.0034084,33.4737152 L21.0034084,33.5860025 C21.0034084,38.0096013 23.7951696,41.6994153 27.5074699,42.535042 C26.8257608,42.7491713 26.1115894,42.856236 25.369593,42.856236 C24.8478769,42.856236 24.3377544,42.801398 23.8461818,42.6943333 C24.8757017,46.318864 27.8691931,48.9615334 31.416863,49.0320394 C28.6413331,51.4814701 25.1469941,52.9385941 21.3512192,52.9385941 C20.697335,52.9385941 20.0504069,52.8994241 19.4173913,52.8132501 C23.0044798,55.4010815 27.2640024,56.9130435 31.8411922,56.9130435 C46.7506807,56.9130435 54.8987278,43.005082 54.8987278,30.9433332 C54.8987278,30.5464105 54.8940904,30.1520992 54.8778592,29.7630105 C56.4615576,28.4756232 57.8388883,26.8670418 58.9217391,25.0364971 C57.4678901,25.7624478 55.9050603,26.2533785 54.268031,26.4727305 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </svg>
    );
    break;
  case 'instagram':
    outIcon = (
      <svg width="34px" height="37px" viewBox="0 0 34 37">
        <desc>Created with Sketch.</desc>
        <defs />
        <g id="Home-Page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            className="social-stroke"
            transform="translate(-606.000000, -3109.000000)"
            id="Group-6"
            strokeWidth="1.33279996"
          >
            <g transform="translate(584.000000, 3089.000000)">
              <path
                d="M28.9764898,21.426087 C25.552448,21.426087 22.7652174,24.3855117 22.7652174,28.0255639 L22.7652174,48.9744361 C22.7652174,52.6144883 25.552448,55.573913 28.9764898,55.573913 L48.6930754,55.573913 C52.1171173,55.573913 54.9043478,52.6144883 54.9043478,48.9744361 L54.9043478,28.0255639 C54.9043478,24.3855117 52.1171173,21.426087 48.6930754,21.426087 L28.9764898,21.426087 Z M34.6736253,35.1521739 L23.0471396,35.1521739 L34.6736253,35.1521739 C35.7151972,33.7298343 37.3406449,32.8086957 39.1686146,32.8086957 C40.9965843,32.8086957 42.622032,33.7298343 43.663604,35.1521739 L54.6224256,35.1521739 L43.663604,35.1521739 C43.7042589,35.2076911 43.7440242,35.2639718 43.7828774,35.3209911 C44.4578108,36.3114153 44.8608696,37.5232758 44.8608696,38.8357891 C44.8608696,42.1573336 42.3075301,44.8608696 39.1686146,44.8608696 C36.0316004,44.8608696 33.4782609,42.1573336 33.4782609,38.8357891 C33.4782609,37.5232758 33.8813197,36.3114153 34.5543518,35.3209911 C34.593205,35.2639718 34.6329703,35.2076911 34.6736253,35.1521739 Z M50.1886028,25.4476457 L50.8869565,25.4434783 L50.8869565,31.4508118 L45.549008,31.4695652 L45.5304348,25.4622316 L50.1886028,25.4476457 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </svg>
    );
    break;
  default:
    break;
  }
  return outIcon;
};



// WEBPACK FOOTER //
// ./src/utils/socialSvg.js